import { animation, size } from './variables';

export const ellipsis = () => `
    box-sizing:border-box;
    width:100%;
    padding: 0 5px;
    overflow:hidden;
    white-space: nowrap;
    text-overflow:ellipsis;
  `;

export const dynamicFontSize = (minFontSize, maxFontSize, minScreenWidth = size.small, maxScreenWidth = size.large) => `
    font-size: ${minFontSize}px;
      @media screen and (min-width: ${minScreenWidth}px) {
        font-size: calc(${minFontSize}px + (${maxFontSize} - ${minFontSize}) * ((100vw - ${minScreenWidth}px) / (${maxScreenWidth} - ${minScreenWidth})));
      }
      @media screen and (min-width: ${maxScreenWidth}px) {
        font-size: ${maxFontSize}px;
      }
  `;

export const selectedBackground = () => `
    position: relative;
    z-index: 1;
    &:before {
      content: '';
      position: absolute;
      right: -0.3em;
      bottom: 0;
      left: -0.3em;
      height: 90%;
      opacity: 1;
      background-color: rgba(197,197,197,.4);
      z-index: -1;
    }
`;

export const fontFamilyHeading = () => `
    font-family: 'Playfair Display', Georgia, serif;
    font-variant-ligatures: no-common-ligatures;
  `;

export const fontFamilyBody = () => `
    font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  `;

export const hideOnPrint = () => `
  @media print {
    display: none !important;
  }
`;

export const showOnPrint = () => `
  display: none !important;
  
  @media print {
    display: inherit !important;
  }
`;

export const hover = content => `
    @media not all and (hover: none) {
      &:hover {
        ${content}
      }
    }
  `;

export const shadowOnHover = () => `
    position: relative;
    z-index: 1;
  
    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      opacity: 0;
      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
      transition: opacity 0.4s ${animation.easing};
    }
    
    ${hover`
      &:before {
        opacity: 1;
      }
    `}
  `;

export const darkenOnHover = () => `
    position: relative;
    z-index: 1;
  
    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0,0,0,.2);
      
      opacity: 0;
      transition: opacity ${animation.transitionTime} ${animation.easing};
    }
    
    ${hover`
      &:after {
        opacity: 1;
      }
    `}
  `;



// WEBPACK FOOTER //
// ./src/styles/helpers/mixins.js